// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2Tzms","fileBtn":"File_fileBtn__2eJSQ","closeBtn":"File_closeBtn__3UQ1j","fileSelected":"File_fileSelected__1i_lS","disabled":"File_disabled__3Tet2"};